import Header from './Header';
import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query-v4';
import { queryClient } from './api';
import { OnboardingFlowsTable } from './OnboardingFlowsTable';

interface OnboardingFlowsPageProps {}

const OnboardingFlowsPage: React.FC<OnboardingFlowsPageProps> = () => {
  return (
    <div className="p-8 flex flex-col gap-4">
      <QueryClientProvider client={queryClient}>
        <Header />
        <OnboardingFlowsTable />
      </QueryClientProvider>
    </div>
  );
};

export default OnboardingFlowsPage;
